import { useApi } from '@omnipresentgroup/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_BASE, VARIANT_PAYMENTS_API_PATH } from '../constants';

export const useDeleteCompensationVariantPaymentMutation = ({
  id,
  employeeId,
}: {
  id: string;
  employeeId: string;
}) => {
  const { DELETE } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return DELETE(`${API_BASE}/${VARIANT_PAYMENTS_API_PATH}/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [VARIANT_PAYMENTS_API_PATH, employeeId],
      });
    },
  });
};
